import { useState, useEffect } from 'react';
import { useSimpleEmpresa } from './useSimpleEmpresa';
import * as configuracionApiService from '../services/configuracionApiService';

/**
 * Hook específico para manejar la configuración del Chat IA
 * Se ejecuta independientemente de la selección de sucursales
 */
export const useChatIAConfig = () => {
  const { empresaActual } = useSimpleEmpresa();
  const [chatIAEnabled, setChatIAEnabled] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchChatIAConfig = async () => {
      try {
        console.log('🤖 [useChatIAConfig] Iniciando carga...', { empresaActual });
        
        // Solo necesitamos la empresa para configuraciones globales
        if (!empresaActual?.id) {
          console.log('🤖 [useChatIAConfig] No hay empresa actual, finalizando');
          setLoading(false);
          return;
        }

        console.log('🤖 [useChatIAConfig] Empresa encontrada:', empresaActual.id);

        // Obtener específicamente la configuración del Chat IA
        const enableChatIA = await configuracionApiService
          .getConfiguracionPorClave('enable_chat_ia')
          .catch((error) => {
            console.log('🤖 [useChatIAConfig] Error obteniendo configuración:', error);
            return 'false';
          });

        console.log('🤖 [useChatIAConfig] Valor obtenido:', enableChatIA);
        
        const isEnabled = enableChatIA === 'true' || enableChatIA === true;
        console.log('🤖 [useChatIAConfig] Chat IA habilitado:', isEnabled);
        
        setChatIAEnabled(isEnabled);

      } catch (error) {
        console.error('❌ Error cargando configuración Chat IA:', error);
        setChatIAEnabled(false);
      } finally {
        setLoading(false);
      }
    };

    fetchChatIAConfig();
  }, [empresaActual?.id]); // Solo depende de la empresa, no de sucursales

  return {
    chatIAEnabled,
    loading
  };
};

export default useChatIAConfig;